<template>
  <b-overlay variant="white" spinner-variant="primary" blur="0" opacity=".75" rounded="sm" :show="isLoading">
    <validation-observer ref="criteriaSaveFormRef">
      <b-modal id="evaluateCreditClassSaveModal" centered size="xl"
        :title="isCreated ? 'Phiếu khảo sát/đánh giá lớp tín chỉ' : 'Cập nhật phiếu khảo sát/đánh giá lớp tín chỉ'"
        no-close-on-backdrop @show="onShow" @hide="onHide" hideFooter>
        <div class="font-weight-bold">
          <b-row class="mx-2 my-2" v-if="studentEvaluate.objectGroupEvaluateTeachers">
            <div class="font-weight-bold">
              <feather-icon
                icon="EditIcon"
                size="22"
              />
              Xếp hạng giảng viên: 
            </div>
          </b-row>
          <div v-if="studentEvaluate.objectGroupEvaluateTeachers">
            <b-row class="ml-2" v-for="(item, index) in studentEvaluate.objectGroupEvaluateTeachers" :key="index">
              <b-col sm="6" md="6" lg="4" xl="4">{{ item.fullName + ' (' + item.lessonNum + ' tiết)' }}</b-col>
              <b-col sm="6" md="6" lg="8" xl="8">
                <div class="item-rating">
                  <ul class="unstyled-list list-inline">
                    <li v-for="star in 5" :key="star" class="ratings-list-item" :class="{ 'ml-25': star - 1 }">
                      <feather-icon icon="StarIcon" size="16" :id="item.teacherId + '_star_' + star"
                        @click="clickStar(item, index, star)" class="star-rate" />
                    </li>
                  </ul>
                </div>
              </b-col>
            </b-row>
          </div>
          <div v-else>
            <b-row class="mx-1">
              <b-col>
                Không có giảng viên nào giảng dạy lớp này
              </b-col>
            </b-row>
          </div>
          <b-row class="mx-2 my-2" v-if="studentEvaluate.objectGroupEvaluateCriterias">
            <div class="font-weight-bold">
              <feather-icon
                icon="EditIcon"
                size="22" 
              />
              Thực hiện trả lời các câu hỏi dưới đây: 
            </div>
          </b-row>
          <div v-if="studentEvaluate.objectGroupEvaluateCriterias">
            <div v-for="(item, index) in studentEvaluate.objectGroupEvaluateCriterias" :key="index" class="mx-3">
              <b-row v-if="item.criteriaType === CRITERIA_TYPES[0].value">
                <b-col cols="12" md="12">
                  <b-form-group :label-for="item.name">
                    <template v-slot:label>
                      {{ (index + 1) + ". " + item.name }} <span class="text-danger">*</span>
                    </template>
                    <vue-slider v-model="item.point" direction="ltr" :max="item.maxPoint" :min="1" style="width: 50%;"
                      class="mx-1 my-2" />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="item.criteriaType === CRITERIA_TYPES[1].value && item.multipleSelect != 1">
                <b-col cols="12" md="12">
                  <b-form-group :label-for="item.name">
                    <template v-slot:label>
                      {{ (index + 1) + ". " + item.name }} <span class="text-danger" v-if="item.required">*</span>
                    </template>
                    <validation-provider #default="{ errors }" name="Câu hỏi này"
                      :rules="(item.required ? 'required' : '')">
                      <b-form-radio-group :id="'skin-radio-group_' + index" v-model="item.evaluationCriteriaOptionId[0]"
                        :name="'skin_' + index" :options="item.evaluationCriteriaOptions"
                        class="custom-control-primary pl-2 radio-group-custom" :state="getElementState(errors)"
                        @input="checkDisabledSubmitButton" />
                      <small class="text-danger mx-1">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="item.criteriaType === CRITERIA_TYPES[1].value && item.multipleSelect === 1">
                <b-col cols="12" md="12">
                  <b-form-group :label-for="item.name">
                    <template v-slot:label>
                      {{ (index + 1) + ". " + item.name }} <span class="text-danger" v-if="item.required">*</span>
                    </template>
                    <validation-provider #default="{ errors }" name="Câu hỏi này"
                      :rules="(item.required ? 'required' : '')">
                      <b-form-checkbox-group :id="'skin2-radio-group_' + index"
                        v-model="item.evaluationCriteriaOptionId" class="custom-control-primary pl-2"
                        :options="item.evaluationCriteriaOptions" :state="getElementState(errors)"
                        @input="checkDisabledSubmitButton" />
                      <small class="text-danger mx-1">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row v-if="item.criteriaType === CRITERIA_TYPES[2].value">
                <b-col cols="12" md="12">
                  <b-form-group :label-for="item.name">
                    <template v-slot:label>
                      {{ (index + 1) + '. ' + item.name }} <span class="text-danger" v-if="item.required">*</span>
                    </template>
                    <validation-provider #default="{ errors }" name="Câu hỏi này"
                      :rules="(item.required ? 'required' : '')">
                      <b-form-textarea :id="'question_' + index" placeholder="Nhập câu trả lời" rows="3"
                        v-model="item.content" :state="getElementState(errors)" class="mx-1 mt-2"
                        @input="checkDisabledSubmitButton" />
                      <small class="text-danger mx-1">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
          <b-row class="mx-2 my-2" v-if="studentEvaluate.rooms && studentEvaluate.rooms.length > 0 && studentEvaluate.rooms[0].objectGroupEvaluateRoomCriterias && studentEvaluate.rooms[0].objectGroupEvaluateRoomCriterias.length > 0">
            <div class="font-weight-bold">
              <feather-icon
                icon="EditIcon"
                size="22"
              />
              Thực hiện trả lời các câu hỏi đánh giá phòng học dưới đây:
            </div>
          </b-row>
          <div v-if="studentEvaluate.rooms && studentEvaluate.rooms.length > 0 && studentEvaluate.rooms[0].objectGroupEvaluateRoomCriterias && studentEvaluate.rooms[0].objectGroupEvaluateRoomCriterias.length > 0">
            <div v-for="(room, index) in studentEvaluate.rooms" :key="index" class="mx-3">
              <b-row>
                <b-col cols="12" md="12" class="mb-2">
                  <feather-icon
                    icon="HomeIcon"
                    size="22"
                  />
                 {{ "Phòng học " + room.roomName + " - " + room.buildingName + "(" + room.roomType + ")" }}
                </b-col>
              </b-row>
              <div v-if="room.objectGroupEvaluateRoomCriterias && room.objectGroupEvaluateRoomCriterias.length > 0">
                <div v-for="(item, index) in room.objectGroupEvaluateRoomCriterias" :key="index" class="mx-3">
                  <b-row v-if="item.criteriaType === CRITERIA_TYPES[0].value">
                    <b-col cols="12" md="12">
                      <b-form-group :label-for="room.id + item.name">
                        <template v-slot:label>
                          {{ (index + 1) + ". " + item.name }} <span class="text-danger">*</span>
                        </template>
                        <vue-slider v-model="item.point" direction="ltr" :max="item.maxPoint" :min="1" style="width: 50%;"
                          class="mx-1 my-2" />
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-if="item.criteriaType === CRITERIA_TYPES[1].value && item.multipleSelect != MULTIPLE_CRITERIA_OPTION_TYPES[1].value">
                    <b-col cols="12" md="12">
                      <b-form-group :label-for="room.id + item.name">
                        <template v-slot:label>
                          {{ (index + 1) + ". " + item.name }} <span class="text-danger" v-if="item.required">*</span>
                        </template>
                        <validation-provider #default="{ errors }" name="Câu hỏi này"
                          :rules="(item.required ? 'required' : '')">
                          <b-form-radio-group :id="room.id + '_room-radio-group_' + index" v-model="item.evaluationCriteriaOptionId[0]"
                            :options="item.evaluationCriteriaOptions"
                            class="custom-control-primary pl-2 radio-group-custom" :state="getElementState(errors)"
                            @input="checkDisabledSubmitButton" />
                          <small class="text-danger mx-1">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-if="item.criteriaType === CRITERIA_TYPES[1].value && item.multipleSelect === MULTIPLE_CRITERIA_OPTION_TYPES[1].value">
                    <b-col cols="12" md="12">
                      <b-form-group :label-for="room.id + item.name">
                        <template v-slot:label>
                          {{ (index + 1) + ". " + item.name }} <span class="text-danger" v-if="item.required">*</span>
                        </template>
                        <validation-provider #default="{ errors }" name="Câu hỏi này"
                          :rules="(item.required ? 'required' : '')">
                          <b-form-checkbox-group :id="room.id + '_room-checkbox-group_' + index"
                            v-model="item.evaluationCriteriaOptionId" class="custom-control-primary pl-2"
                            :options="item.evaluationCriteriaOptions" :state="getElementState(errors)"
                            @input="checkDisabledSubmitButton" />
                          <small class="text-danger mx-1">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row v-if="item.criteriaType === CRITERIA_TYPES[2].value">
                    <b-col cols="12" md="12">
                      <b-form-group :label-for="room.id + item.name">
                        <template v-slot:label>
                          {{ (index + 1) + '. ' + item.name }} <span class="text-danger" v-if="item.required">*</span>
                        </template>
                        <validation-provider #default="{ errors }" name="Câu hỏi này"
                          :rules="(item.required ? 'required' : '') + 'max:1000'">
                          <b-form-textarea :id="room.id + '_room_question_' + index" placeholder="Nhập câu trả lời" rows="3"
                            v-model="item.content" :state="getElementState(errors)" class="mx-1 mt-2"
                            @input="checkDisabledSubmitButton" />
                          <small class="text-danger mx-1">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                  </b-row>
                </div>
              </div>
            </div>
          </div>
          <div v-if="studentEvaluate.objectGroupEvaluateCriterias && studentEvaluate.objectGroupEvaluateCriterias.length === 0 && studentEvaluate.rooms && studentEvaluate.rooms.length === 0">
            <b-row>
              <b-col cols="12" md="12">
                <div class="text-center my-2"><b>Không có câu hỏi khảo sát/đánh giá nào!</b></div>
              </b-col>
            </b-row>
          </div>
          <template v-if="studentEvaluate.objectGroupEvaluateCriterias && studentEvaluate.objectGroupEvaluateCriterias.length > 0 || (studentEvaluate.rooms && studentEvaluate.rooms.length > 0 && studentEvaluate.rooms[0].objectGroupEvaluateRoomCriterias.length > 0)">
            <div class="w-100 d-flex justify-content-end my-1">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" class="mr-1"
                :disabled="isDisabledSubmitButton" @click="onSave('hide')">
                <span class="text-right">
                  <feather-icon icon="CheckIcon" /> Gửi đánh giá
                </span>
              </b-button>
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="outline-secondary"
                @click="$bvModal.hide('evaluateCreditClassSaveModal')">
                <span class="text-right"> <feather-icon icon="XIcon" /> Hủy </span>
              </b-button>
            </div>
          </template>
        </div>
      </b-modal>
    </validation-observer>
  </b-overlay>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BModal, BOverlay, BFormInvalidFeedback, BButton, BRow, BCol, BTable, BFormTextarea,
  BFormDatepicker,
  BCardHeader,
  BCardTitle,
  BFormRadioGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import * as events from 'events'
import { getUser } from '@/auth/utils'
import VueSlider from 'vue-slider-component'
import { CRITERIA_TYPES, MULTIPLE_CRITERIA_OPTION_TYPES, REQUIRED } from '@/const/type'

export default {
  name: 'CriteriaSave',
  components: {
    BFormRadioGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    BFormGroup,
    BFormInput,
    BModal,
    BForm,
    BOverlay,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BTable,
    BFormTextarea,
    BFormDatepicker,
    BCardHeader,
    BCardTitle,
    VueSlider,
  },
  directives: {
    Ripple,
  },
  props: {
    mainData: {
      type: Object,
      default: undefined,
    },
    setOfCriteriaObjectId: {
      type: Number,
      default: null,
    },
    evaluateObjectGroupId: {
      type: Number,
      default: null,
    },
    setOfEvaluateLevelId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      required,
      isCheckCriterias: true,
      isCheckCriteriaTypeSliders: true,
      isDisabledSubmitButton: false,
      CRITERIA_TYPES,
      MULTIPLE_CRITERIA_OPTION_TYPES,
    }
  },
  computed: {
    events() {
      return events
    },
    ...mapGetters({
      studentEvaluate: 'studentEvaluate/studentEvaluate'
    }),
    isCreated() {
      return this.studentEvaluate.id === null
    },
  },
  methods: {
    ...mapMutations({
      setStudentEvaluate: 'studentEvaluate/SET_STUDENT_EVALUATE',
    }),
    ...mapActions({
      createStudentEvaluate: 'studentEvaluate/createStudentEvaluate',
      updateStudentEvaluate: 'studentEvaluate/updateStudentEvaluate',
      getStudentEvaluate: 'studentEvaluate/getStudentEvaluate'
    }),
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
    async onShow() {
      this.isLoading = true
      await this.getStudentEvaluate({
        studentCreditClassId: this.mainData.studentCreditClassId, organizationId: this.user.orgId, setOfCriteriaObjectId: this.setOfCriteriaObjectId, evaluateObjectGroupId: this.evaluateObjectGroupId
      })
      this.isDisabledSubmitButton = false
      if(this.studentEvaluate.objectGroupEvaluateCriterias) {
        for (let i = 0; i < this.studentEvaluate.objectGroupEvaluateCriterias.length; i++) {
          if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[0].value && this.studentEvaluate.objectGroupEvaluateCriterias[i].point === 0) {
            this.isDisabledSubmitButton = true
            break;
          }
          if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[1].value && this.studentEvaluate.objectGroupEvaluateCriterias[i].required === REQUIRED[1].value && this.studentEvaluate.objectGroupEvaluateCriterias[i].evaluationCriteriaOptionId.length === 0) {
            this.isDisabledSubmitButton = true
            break;
          }
          if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[2].value && this.studentEvaluate.objectGroupEvaluateCriterias[i].required === REQUIRED[1].value && (this.studentEvaluate.objectGroupEvaluateCriterias[i].content === '' || this.studentEvaluate.objectGroupEvaluateCriterias[i].content === null)) {
            this.isDisabledSubmitButton = true
            break;
          }
        }
      }

      //Check show point for each criteria option
      if(this.setOfEvaluateLevelId && this.setOfEvaluateLevelId > 0) {
        for (let i = 0; i < this.studentEvaluate.objectGroupEvaluateCriterias.length; i++) {
          if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[1].value) {
            this.studentEvaluate.objectGroupEvaluateCriterias[i].evaluationCriteriaOptions.forEach(option => {
              option.text = option.text + " (" + option.point + " điểm)"
            })
          }
        }
      }
      
      if(this.studentEvaluate.rooms && this.studentEvaluate.rooms[0].objectGroupEvaluateRoomCriterias) {
        for (let i = 0; i < this.studentEvaluate.rooms.length; i++) {
          for (let j = 0; j < this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias.length; j++) {
            if (this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].criteriaType === CRITERIA_TYPES[0].value && this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].point === 0) {
              this.isDisabledSubmitButton = true
              break;
            }
            if (this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].criteriaType === CRITERIA_TYPES[1].value && this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].required === REQUIRED[1].value && this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].evaluationCriteriaOptionId.length === 0) {
              this.isDisabledSubmitButton = true
              break;
            }
            if (this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].criteriaType === CRITERIA_TYPES[2].value && this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].required === REQUIRED[1].value && (this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].content === '' || this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].content === null)) {
              this.isDisabledSubmitButton = true
              break;
            }
          }

          //Check show point for each criteria option room
          if(this.setOfEvaluateLevelId && this.setOfEvaluateLevelId > 0) {
            for (let j = 0; j < this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias.length; j++) {
              if (this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].criteriaType === CRITERIA_TYPES[1].value) {
                this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].evaluationCriteriaOptions.forEach(option => {
                  option.text = option.text + " (" + option.point + " điểm)"
                })
              }
            }
          }
        }
      }
      
      this.isLoading = false
    },
    onHide() {
      this.isLoading = false
      this.setStudentEvaluate({})
      this.$refs.criteriaSaveFormRef.reset()
      if(this.studentEvaluate.id === null) {
        for (let i = 0; i < this.studentEvaluate.objectGroupEvaluateCriterias.length; i++) {
          if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[1].value) {
            this.studentEvaluate.objectGroupEvaluateCriterias[i].evaluationCriteriaOptionId = []
          }
        }
      }
    },
    async onSave(type = null) {
      const valid = this.$refs
        .criteriaSaveFormRef
        .validate()
      if (valid) {
        this.isLoading = true
        try {
          const response = this.isCreated
            ? await this.createStudentEvaluate(this.studentEvaluate)
            : await this.updateStudentEvaluate(this.studentEvaluate)
          if (response) {
            const {
              isSuccessful,
              message,
            } = response
            if (isSuccessful) {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'CheckIcon',
                  variant: 'success',
                },
              })
              if (type === 'hide') {
                this.$bvModal.hide('evaluateCreditClassSaveModal')
              }
              this.$emit('succeed')
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: message,
                  icon: 'XCircleIcon',
                  variant: 'danger',
                },
              })
            }
          }
        } catch (e) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: `[${e.code}] ${e.message}`,
              icon: 'XCircleIcon',
              variant: 'danger',
            },
          })
        } finally {
          this.isLoading = false
        }
      }
    },
    showToast(title, icon, variant, autoHideDelay = 1000) {
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title,
          icon,
          variant,
          autoHideDelay,
        },
      })
    },
    clickStar(item, index, star) {
      for (let i = 1; i <= 5; i++) {
        let elementId = document.getElementById(item.teacherId + '_star_' + i)
        elementId?.classList.remove('fill-current')
        elementId?.classList.remove('text-warning')
        if (i <= star) {
          elementId?.classList.add('fill-current')
          elementId?.classList.add('text-warning')
        } else {
          elementId?.classList.remove('text-muted')
        }
      }
      this.studentEvaluate.objectGroupEvaluateTeachers[index].rate = star
    },
    checkDisabledSubmitButton() {
      this.isDisabledSubmitButton = false
      if(this.studentEvaluate.objectGroupEvaluateCriterias) {
        for (let i = 0; i < this.studentEvaluate.objectGroupEvaluateCriterias.length; i++) {
          if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[0].value && this.studentEvaluate.objectGroupEvaluateCriterias[i].point === 0) {
            this.isDisabledSubmitButton = true
            break;
          }
          if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[1].value && this.studentEvaluate.objectGroupEvaluateCriterias[i].required === REQUIRED[1].value && this.studentEvaluate.objectGroupEvaluateCriterias[i].evaluationCriteriaOptionId.length === 0) {
            this.isDisabledSubmitButton = true
            break;
          }
          if (this.studentEvaluate.objectGroupEvaluateCriterias[i].criteriaType === CRITERIA_TYPES[2].value && this.studentEvaluate.objectGroupEvaluateCriterias[i].required === REQUIRED[1].value && (this.studentEvaluate.objectGroupEvaluateCriterias[i].content === '' || this.studentEvaluate.objectGroupEvaluateCriterias[i].content === null)) {
            this.isDisabledSubmitButton = true
            break;
          }
        }
      }

      if(this.studentEvaluate.rooms && this.studentEvaluate.rooms[0].objectGroupEvaluateRoomCriterias) {
        for (let i = 0; i < this.studentEvaluate.rooms.length; i++) {
          for (let j = 0; j < this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias.length; j++) {
            if (this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].criteriaType === CRITERIA_TYPES[0].value && this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].point === 0) {
              this.isDisabledSubmitButton = true
              break;
            }
            if (this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].criteriaType === CRITERIA_TYPES[1].value && this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].required === REQUIRED[1].value && this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].evaluationCriteriaOptionId.length === 0) {
              this.isDisabledSubmitButton = true
              break;
            }
            if (this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].criteriaType === CRITERIA_TYPES[2].value && this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].required === REQUIRED[1].value && (this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].content === '' || this.studentEvaluate.rooms[i].objectGroupEvaluateRoomCriterias[j].content === null)) {
              this.isDisabledSubmitButton = true
              break;
            }
          }
        }
      }
    },
  },
  watch: {
    studentEvaluate(newVal, oldVal) {
      this.studentEvaluate = newVal

      setTimeout(() => {
        this.studentEvaluate?.objectGroupEvaluateTeachers?.forEach((item, index) => {
          this.clickStar(item, index, item.rate)
        })
      }, 50)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/vue/libs/vue-slider.scss';

.option-index {
  width: 20px;
}

.star-rate {
  cursor: pointer;
}

#evaluateCreditClassSaveModal label {
  font-size: 1rem;
}

#evaluateCreditClassSaveModal .vue-slider-handle-end {
  display: none;
  pointer-events: none;
}
</style>
